import { render, staticRenderFns } from "./StandardManage.vue?vue&type=template&id=770135f5&scoped=true&"
import script from "./StandardManage.vue?vue&type=script&lang=js&"
export * from "./StandardManage.vue?vue&type=script&lang=js&"
import style0 from "./StandardManage.vue?vue&type=style&index=0&id=770135f5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "770135f5",
  null
  
)

export default component.exports